import styled from 'styled-components';

export const Table = styled.table`
  table-layout: fixed;

  th:nth-of-type(1) {
    width: 40%
  }

  th {
    width: 30%
  }

  td {
    padding: 5px 0 5px 0;
  }

  td:nth-of-type(2) {
    padding: 5px 5px 5px 0;
    display: grid;
  }
`;
